<template>
  <div v-show="flag" class="mdl-card" centered>
    <div class="mdl-card__title mdl-card--expand">
      <div class="mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active" centered></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      flag: true
    }
  },
  methods: {
    show () {
      return this.flag = true
    },
    hide () {
      return this.flag = false
    }
  },
  mounted () {
    this.$loading.show = this.show
    this.$loading.hide = this.hide
    componentHandler.upgradeElement(this.$el)
  }
}
</script>

<style lang="css" scoped>
  .mdl-card {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #2e2e2e;
    opacity: 0.75;
    z-index: 10;
  }

  [centered] {
    margin: auto;
  }
</style>


// WEBPACK FOOTER //
// index.vue?24b85864